<div class="tab-panel">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
        <li
            [ngbNavItem]="0"
            (click)="clickActiveTab(tabList)"
        >
            <a ngbNavLink>{{ tabList.capacity === 'SELLER'?buyerSellerText['transferringText']:buyerSellerText['acquiringText'] }} {{ tabList.fullName }} - {{ tabList.addressEstate }}

              <ng-container *ngIf="tabList.descriptionEstate">({{tabList.descriptionEstate}})</ng-container>
            </a>
            <ng-template ngbNavContent>
                <ng-content></ng-content>
            </ng-template>
        </li>
    </ul>

    <div [ngbNavOutlet]="nav"></div>
</div>
